(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .controller('RptCategoryDetailController', RptCategoryDetailController);

    RptCategoryDetailController.$inject = ['$scope', '$rootScope', '$stateParams', 'previousState', 'entity', 'RptCategory', 'Clinic'];

    function RptCategoryDetailController($scope, $rootScope, $stateParams, previousState, entity, RptCategory, Clinic) {
        var vm = this;

        vm.rptCategory = entity;
        vm.previousState = previousState.name;

        var unsubscribe = $rootScope.$on('dialysisApp:rptCategoryUpdate', function(event, result) {
            vm.rptCategory = result;
        });
        $scope.$on('$destroy', unsubscribe);
    }
})();
